import { createAction } from '@reduxjs/toolkit';
import { AccountSettings } from './action-types';

const toggleIsOpen = createAction<boolean>(AccountSettings.TOGGLE_IS_OPEN);

const saveFormData = createAction<CMx.AccountDefaultsDataObject>(
  AccountSettings.SAVE_FORM_DATA
);

const updateFormDefinition = createAction<CMx.Context>(
  AccountSettings.UPDATE_FORM_DEFINITION
);

export { toggleIsOpen, saveFormData, updateFormDefinition };
